var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOracleDb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15814",
    "data-name": "Group 15814",
    transform: "translate(-752 -2154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1958",
    "data-name": "Rectangle 1958",
    transform: "translate(752 2154)",
    fill: "#fff",
    stroke: "#C74634",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bee6232fdcbca080b23a816c64bf9565",
    transform: "translate(678.5 2146)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C74634",
    id: "Path_19044",
    "data-name": "Path 19044",
    d: "M106.629,184.517c11.312-.135,20.816,2.87,21.214,6.7s-8.467,7.052-19.779,7.182-20.821-2.865-21.214-6.7S95.312,184.652,106.629,184.517Z",
    transform: "translate(-7.92 -165.999)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C74634",
    id: "Path_19045",
    "data-name": "Path 19045",
    d: "M86.815,348.278a2.05,2.05,0,0,1,0-.491V340.2h.01a2.293,2.293,0,0,0,0,.486c.393,3.831,9.9,6.831,21.214,6.7,10.826-.13,19.406-3.08,19.779-6.691v7.588H127.8c-.364,3.611-8.949,6.571-19.779,6.7-11.307.125-20.816-2.875-21.209-6.706Z",
    transform: "translate(-7.884 -314.103)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C74634",
    id: "Path_19046",
    "data-name": "Path 19046",
    d: "M86.815,525.578a2.049,2.049,0,0,1,0-.491V517.5h.01a2.293,2.293,0,0,0,0,.486c.393,3.831,9.9,6.831,21.214,6.7,10.826-.13,19.406-3.085,19.779-6.691v7.583H127.8c-.359,3.616-8.944,6.571-19.774,6.7-11.312.13-20.816-2.87-21.214-6.7Z",
    transform: "translate(-7.884 -482.76)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C74634",
    id: "Path_19047",
    "data-name": "Path 19047",
    d: "M86.815,702.878a2.05,2.05,0,0,1,0-.491V694.8h.01a2.293,2.293,0,0,0,0,.486c.393,3.831,9.9,6.831,21.214,6.7,10.826-.13,19.406-3.08,19.779-6.691v7.587H127.8c-.364,3.616-8.949,6.571-19.779,6.7C96.717,709.715,87.213,706.71,86.815,702.878Z",
    transform: "translate(-7.884 -651.417)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C74634",
    id: "Path_19048",
    "data-name": "Path 19048",
    d: "M109.075,10h-.87v5.82h4.084l.555-.952H109.08V10Zm-11.912.29-3.184,5.534h1.052l.958-1.673h2.054l.541-.952H96.53l1.12-1.918,2.619,4.537h1.057l-3.214-5.544a.545.545,0,0,0-.948.015Zm6.177.661h3.651l.541-.947h-4.216c-1.469,0-2.437,1.3-2.437,2.91s.968,2.91,2.437,2.91l3.568-.005.56-.942h-4.1c-.988,0-1.568-.876-1.568-1.963S102.348,10.952,103.341,10.952ZM84.7,10H80.932c-1.469,0-2.432,1.3-2.432,2.91s.968,2.91,2.432,2.91H84.7c1.469,0,2.432-1.3,2.432-2.91S86.161,10,84.7,10Zm0,4.873H80.932c-.988,0-1.568-.876-1.568-1.963s.575-1.958,1.568-1.958H84.7c.988,0,1.568.876,1.568,1.963S85.684,14.873,84.7,14.873Zm29.1-1.5h4.6l.555-.952H113.8a1.588,1.588,0,0,1,1.528-1.472h3.656l.541-.947h-4.216c-1.469,0-2.432,1.3-2.432,2.91s.968,2.91,2.432,2.91l3.568-.005.56-.942h-4.1a1.59,1.59,0,0,1-1.533-1.5Zm-21.715.085a1.657,1.657,0,0,0,1.577-1.728A1.66,1.66,0,0,0,92.083,10H87.65v5.82h.973V10.952h3.455a.785.785,0,0,1,0,1.563H89.306l3.125,3.305h1.258l-2.236-2.354Z",
    transform: "translate(0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOracleDb);
export default __webpack_public_path__ + "static/media/OracleDB.3407fa4e6dde745d51335f50f478f73c.svg";
export { ForwardRef as ReactComponent };